import { IAction } from '@/utility/redux/action';
interface ILocalitySearchState {
  shouldMergeForm: boolean;
}

export const initialState: ILocalitySearchState = {
  shouldMergeForm: false,
};

const SET_SHOULD_MERGE_FORM = 'localitySearch/SET_SHOULD_MERGE_FORM';

export interface IShouldMergeForm extends IAction {
  type: typeof SET_SHOULD_MERGE_FORM;
  payload: boolean;
}

type TAction = IShouldMergeForm;

export const setShouldMergeForm = (shouldMerge: boolean): IShouldMergeForm => ({
  type: SET_SHOULD_MERGE_FORM,
  payload: shouldMerge,
});

export default function reducer(state = initialState, action: TAction) {
  switch (action.type) {
    case SET_SHOULD_MERGE_FORM:
      return {
        ...state,
        shouldMergeForm: action.payload,
      };
    default:
      return state;
  }
}
